import { Resource as e, API as i } from "@coveo/platform-client";
const t = class t extends e {
  /**
   * Sends a query to the Customer Service API, CRGA Dashboard endpoint.
   *
   * This API enforces Knowledge owned privileges and checks wether the table queried is allow-listed
   * and then calls the Data API.
   *
   * Since the CrgaDashboard is acting as a pass-through it is re-using DataService models.
   */
  query(a, s) {
    return this.api.post(
      this.buildPath(`${t.baseUrl}/dataquery`),
      a,
      s
    );
  }
};
t.baseUrl = `/rest/organizations/${i.orgPlaceholder}/crgadashboard/v1`;
let r = t;
export {
  r as CRGADashboardResource
};
//# sourceMappingURL=CRGADashboardResource.js.map
